var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 9.37509V13.5418M12.5001 17.7084H12.5105M10.7188 4.02092L1.89589 18.7501C1.71398 19.0651 1.61773 19.4223 1.61671 19.7861C1.61569 20.1498 1.70994 20.5075 1.89008 20.8236C2.07022 21.1396 2.32997 21.403 2.6435 21.5874C2.95702 21.7719 3.31338 21.8711 3.67714 21.8751H21.323C21.6867 21.8711 22.0431 21.7719 22.3566 21.5874C22.6701 21.403 22.9299 21.1396 23.11 20.8236C23.2902 20.5075 23.3844 20.1498 23.3834 19.7861C23.3824 19.4223 23.2861 19.0651 23.1042 18.7501L14.2813 4.02092C14.0956 3.71479 13.8341 3.46167 13.5221 3.28601C13.2101 3.11035 12.8581 3.01807 12.5001 3.01807C12.142 3.01807 11.79 3.11035 11.478 3.28601C11.166 3.46167 10.9045 3.71479 10.7188 4.02092Z",
    stroke: "#525252",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportOff);
export default __webpack_public_path__ + "static/media/report-off.1f4e2e57f65748569683e272eff74144.svg";
export { ForwardRef as ReactComponent };